import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'terms-and-conditions',
        path: `terms-and-conditions`,
        component: React.lazy(() => import('views/public-views/tnc')),
    },
    {
        key: 'privacy-policy',
        path: `privacy-policy`,
        component: React.lazy(() => import('views/public-views/pp')),
    },
    {
        key: 'reset-password',
        path: `reset-password`,
        component: React.lazy(() => import('views/public-views/reset-password')),
    },
]

export const protectedRoutes = [
    {
        key: 'dashboard',
        path: `${APP_PREFIX_PATH}/dashboard`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    {
        key: 'claims',
        path: `${APP_PREFIX_PATH}/claims`,
        component: React.lazy(() => import('views/app-views/claims')),
    },
    {
        key: 'new-claim',
        path: `${APP_PREFIX_PATH}/claims/create`,
        component: React.lazy(() => import('views/app-views/claims/create')),
    },
    {
        key: 'claim',
        path: `${APP_PREFIX_PATH}/claim/:id`,
        component: React.lazy(() => import('views/app-views/claims/view')),
    },
    {
        key: 'members',
        path: `${APP_PREFIX_PATH}/members`,
        component: React.lazy(() => import('views/app-views/members')),
    },
    {
        key: 'member',
        path: `${APP_PREFIX_PATH}/member/:id`,
        component: React.lazy(() => import('views/app-views/members/view')),
    },
    {
        key: 'subscriptions',
        path: `${APP_PREFIX_PATH}/subscriptions`,
        component: React.lazy(() => import('views/app-views/subscriptions')),
    },
    {
        key: 'payments',
        path: `${APP_PREFIX_PATH}/payments`,
        component: React.lazy(() => import('views/app-views/payments')),
    },
    {
        key: 'subscription',
        path: `${APP_PREFIX_PATH}/subscription/:id`,
        component: React.lazy(() => import('views/app-views/subscriptions/view')),
    },
    {
        key: 'collections',
        path: `${APP_PREFIX_PATH}/collections`,
        component: React.lazy(() => import('views/app-views/collections')),
    },
    {
        key: 'collection',
        path: `${APP_PREFIX_PATH}/collection/create`,
        component: React.lazy(() => import('views/app-views/collections/create')),
    },
    {
        key: 'plans',
        path: `${APP_PREFIX_PATH}/plans`,
        component: React.lazy(() => import('views/app-views/plans')),
    },
    {
        key: 'plan',
        path: `${APP_PREFIX_PATH}/plan/:id`,
        component: React.lazy(() => import('views/app-views/plans/view')),
    },
    {
        key: 'tnc',
        path: `${APP_PREFIX_PATH}/tnc`,
        component: React.lazy(() => import('views/resources/tnc')),
    },
    {
        key: 'pp',
        path: `${APP_PREFIX_PATH}/pp`,
        component: React.lazy(() => import('views/resources/pp')),
    },
    {
        key: 'profile',
        path: `${APP_PREFIX_PATH}/profile`,
        component: React.lazy(() => import('views/app-views/profile')),
    },
]
